
export const config = {
    abiStoreUrl: 'https://static.matic.network/network/'
};